import { c, classy, color } from '@onfido/castor';
import React from 'react';
import { withRef } from '../../utils';
/**
 * `Icon` requires `Icons` (SVG sprite) to be included in your app. If you wish
 * to use individual inlined SVGs, use generated components from
 * `@onfido/castor-icons` instead.
 *
 * https://github.com/onfido/castor-icons
 *
 * Requires either `aria-hidden="true"` or `aria-label` for accessibility.
 */
export const Icon = withRef(function Icon({ name, color: token, className, ...restProps }, ref) {
    return (React.createElement("svg", { ...restProps, ref: ref, fill: token ? color(token) : 'currentColor', focusable: "false", className: classy(c('icon'), className) },
        React.createElement("use", { href: `#${name}` })));
});
//# sourceMappingURL=icon.js.map